import { render, staticRenderFns } from "./HistoricalArchiveIndex.vue?vue&type=template&id=92bb6ce2"
import script from "./HistoricalArchiveIndex.vue?vue&type=script&lang=js"
export * from "./HistoricalArchiveIndex.vue?vue&type=script&lang=js"
import style0 from "./HistoricalArchiveIndex.vue?vue&type=style&index=0&id=92bb6ce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports